export { isFedRamp } from './services/host-based-lookup/is-fedramp';
export { getATLContextDomain } from './services/host-based-lookup/domain-lookup/getATLContextDomain';
export { getATLContextUrl } from './services/host-based-lookup/domain-lookup/getATLContextUrl';
export type { Perimeter, DomainConfig } from './common/constants/host-based-lookup/types';
export { isFedrampModerate } from './services/perimeter/isFedrampModerate';
export { isIsolatedCloud } from './services/perimeter/isIsolatedCloud';
export { isolatedCloudDomain } from './services/perimeter/isolatedCloudDomain';
export { isolationContextId } from './services/perimeter/isolationContextId';
export { getDomainInContext } from './services/generalized-domain-lookup/getDomainInContext';
export { getUrlForDomainInContext } from './services/generalized-domain-lookup/getUrlForDomainInContext';
